import { $http } from "../config";

const Notifications = {
	getAllNotifications: (read) => $http(`/notification${read ? `?read=${read}` : ''}`).then(r => r.data),
	markAsRead: (notificationId, read) => $http.put(`/notification/${notificationId}${read ? `?read=${read}` : ''}`).then(r => r.data),
	markAllAsRead: (read) => $http.put(`/notification${read ? `?read=${read}` : ''}`).then(r => r.data),
};

export default Notifications;